const PLATFORM_CONFIG: Record<string, { color: string; label: string; icon: string }> = {
  meta: { color: "#1877F2", label: "Meta", icon: "M" },
  tiktok: { color: "#000000", label: "TikTok", icon: "T" },
};

interface PlatformBadgeProps {
  slug: string;
  size?: "sm" | "md";
}

export function PlatformBadge({ slug, size = "sm" }: PlatformBadgeProps) {
  const config = PLATFORM_CONFIG[slug] || { color: "#6366F1", label: slug, icon: slug.charAt(0).toUpperCase() };
  const dim = size === "sm" ? "w-4 h-4 text-[8px]" : "w-5 h-5 text-[10px]";

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-bold text-white flex-shrink-0 ${dim}`}
      style={{ background: config.color }}
      title={config.label}
      data-testid={`platform-badge-${slug}`}
    >
      {config.icon}
    </span>
  );
}
